<template>
	<div class="page page--message layout">
		<div class="layout__header layout__header--msg">
			<h2>美力家园消息箱</h2>
			<div><input type="checkbox" v-model="unread" />筛选未读</div>
		</div>
		<div class="layout__body">
			<div class="msg_list">
				<div class="msg_item" v-for="message in messageList" :key="message.id" @click="goArtical(message)">
					<table class="msg_table">
						<tr>
							<td rowspan="3" style="width:70px;text-align:center">
								<img :src="message.channelImage" class="msg_img"/>
							</td>
							<td>
								<div class="msg_channel_name" style="float:left">{{message.channelName}}</div>
								<div class="msg_unread" v-if="message.read === 0">未读消息</div>
							</td>
						</tr>
						<tr>
							<td v-html="message.content"></td>
						</tr>
						<tr>
							<td class="msg_time" style="">{{message.str_created_at}}</td>
						</tr>
					</table>
				</div>
			</div>
			<!-- <div class="message__list">
				<a class="message__item" v-for="message in messageList" :key="message.id" @click="goArtical(message)">
					<div v-if="message.read === 0" class="message__status">未读消息</div>
					<div style="">
						<img :src="message.src" style="width:64px;height:64px;padding-top:20px;padding-left:20px;"/>
					</div>
					<div style="" class="message__content">
						<div class="message__summary" style="margin-top:-150px; margin-left:120px">{{message.content}}</div>
					</div>
					<div class="message__time">{{message.created_at}}</div>
				</a>
			</div> -->
		</div>
	</div>
</template>
<script>
// @ is an alias to /src
import API from '@/api.js';
// var $win = $(window);
// var $doc = $(document);
// var loadding = false;
export default {
	name: 'home',
	data () {
		const unread = (localStorage.getItem('unread') === 'true');
		// console.log(`initial: unread=${unread}, typeof unread=${typeof unread}`);
		return {
			hasMsg: 0, // 是否存在未读消息
			messageList: [], // 消息箱列表
			lodding: false,
			unread,
			page: 1,
			pageSize: 10
		};
	},
	methods: {
		getMessage () {
			API.getMsgList(this.unread ? 1 : 0, this.page, this.pageSize).then((res) => {
				// console.log('In MljyMessage: msgList=', JSON.stringify(res));
				if (res.status === 200) {
					if (!res.data.length) {

					} else {
						if (this.page === 1) {
							this.messageList = [];
						}
						this.messageList = this.messageList.concat(res.data);
						this.page++;
					}
					this.lodding = false;
				}
			});
		},
		goArtical (data) {
			API.readMsg(data.id);
			if (data.richContent) {
				this.$router.push(`/artical/box/${data.id}`);
			}
		},
		getScrollTop () {
			let scrollTop = 0;
			let bodyScrollTop = 0;
			let documentScrollTop = 0;
			if (document.body) {
				bodyScrollTop = document.body.scrollTop;
			}
			if (document.documentElement) {
				documentScrollTop = document.documentElement.scrollTop;
			}
			scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
			return scrollTop;
		},
		getScrollHeight () {
			let scrollHeight = 0;
			let bSH;
			let dSH;
			if (document.body) {
				bSH = document.body.scrollHeight;
			}
			if (document.documentElement) {
				dSH = document.documentElement.scrollHeight;
			}
			scrollHeight = (bSH - dSH > 0) ? bSH : dSH;
			return scrollHeight;
		},
		getWindowHeight () {
			let windowHeight = 0;
			if (document.compatMode === 'CSS1Compat') {
				windowHeight = document.documentElement.clientHeight;
			} else {
				windowHeight = document.body.clientHeight;
			}
			return windowHeight;
		},
		setWechat () {
			let self = this;
			API.getWechatAssign().then((res) => {
				let data = res.data.data;
				self.$wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['hideOptionMenu', 'showOptionMenu']
				});
				self.$wx.ready(function () {
					self.$wx.showOptionMenu();
				});
				self.$wx.showOptionMenu();
			});
		}
	},
	watch: {
		unread: function (val) {
			// console.log(`unread: val=${val}, typeof val=${typeof val}`);
			localStorage.setItem('unread', val);
			this.messageList = [];
			this.loading = true;
			this.page = 1;
			API.getMsgList(val ? 1 : 0).then((res) => {
				// console.log('In MljyMessage: msgList=', JSON.stringify(res));
				if (res.status === 200) {
					if (!res.data.length) {
					} else {
						this.messageList = res.data;
					}
					this.lodding = false;
				}
			});
		}
	},
	created () {
	},
	mounted () {
		let _self = this;
		_self.loading = true;
		_self.getMessage();
		window.onscroll = function () {
			if (!document.querySelector('.page--message')) {
				return;
			}
			// console.log(`this.unread: val=${_self.unread}, typeof=${typeof _self.unread}`);
			if (_self.getScrollTop() + _self.getWindowHeight() === _self.getScrollHeight() && !_self.lodding && !_self.unread) {
				_self.lodding = true;
				_self.getMessage();
			}
		};
		_self.setWechat();
		_self.$wx.showOptionMenu();
	}
};
</script>
<style scoped>

.msg_item {
	padding:0px 15px 0px 15px;
	border-bottom: 1px solid #EFEFEF;
}

.msg_table {
	width:100%;
	margin-top:5px;
	table-layout:fixed;
	color:#444444;
}

.msg_table tr td {
	padding:3px;
}

.msg_img {
	width:64px;
	height:64px;
}

.msg_channel_name {
	float:left;
	color:#1b77ff;
}

.msg_unread {
	float:right;
	color:#cc4f4f;
}

.msg_time {
	color:#888888;
}
</style>
